<template>
  <div class="animated fadeIn">
    <b-row>
      <DeliveredTotalByFNS :lgSize="12" :lgOffset="0" :locParam="0" />
      <DeliveredTotalByEmail :lgSize="12" :lgOffset="0" :locParam="0" />
    </b-row>
  </div>
</template>

<script>
import DeliveredTotalByFNS from "../../../components/proof-of-delivery/DeliveredTotalByFNS.vue";
import DeliveredTotalByEmail from "../../../components/proof-of-delivery/DeliveredTotalByEmail";

export default {
  name: "ProofOfDelivery",
  components: { DeliveredTotalByFNS, DeliveredTotalByEmail }
};
</script>
